<template>
  <div class="chat-container w-100 position-relative">
    <span id="merchant"></span>
    <transition>
      <div class="w-100 fixed-top" v-show="action_success.show">
        <b-row class="justify-content-center" no-gutters>
          <b-col cols="12" sm="8" md="6" lg="4" xl="4">
            <div class="p-3 border mb-3 radius-0 text-center" style="background-color: rgb(243, 255, 249); border-color: rgb(184, 254, 205) !important;">
              <p class="mb-0 body-3-1">{{action_success.message}}</p>
            </div>  
          </b-col>
        </b-row>
      </div>
    </transition>
    <div class="w-100" style="height: 250px !important;" v-if="getMerchant().merchant_images.length == 0">
      <img :src="getMerchant().image_url" class="img-fit" height="150">
    </div>
    <div class="mb-2" v-else>
      <flickity ref="flickity" :options="flickityOptions">
        <div class="carousel-cell w-100" id="carousel-cell1" v-for="slider_merchant in  getMerchant().merchant_images">
          <div class="w-100" style="height: 250px !important;" >
            <img :src="slider_merchant.image_url" class="img-fit" height="150">
          </div>
        </div>
      </flickity>
    </div>
    <div class="container">
      <div class="px-2 pt-3 pb-2">
        <p class="mb-0 heading-5 text-color-dark">{{getMerchant().name}}</p>
        <img src="../../assets/img/icon/location.png" class="d-inline-block" width="10">
        <p class="mb-0 d-inline-block ml-1 body-2-2-1">{{merchant_area}}</p>
      </div>
    </div>
    <div class="container mb-2" style="background-color: #F6FAF0">
      <div class="px-2 pt-3 pb-2">
        <img src="../../assets/img/icon/calendar.png" class="d-inline-block mr-2" width="16">
        <p class="d-inline-block body-2-4 text-black mb-2" v-if="is_today_available">{{$t('merchant.available-today')}}</p>
        <p class="d-inline-block body-2-4 text-black mb-2" v-else>{{$t('merchant.today-is-close')}}</p>
        <div class="d-block">
          <template v-if="is_today_available">
            <img src="../../assets/img/icon/clock.png" class="d-inline-block mr-2" width="16">
            <p class="d-inline-block body-2-4 text-black mb-0">{{$t('merchant.opening-hours')}}</p>
            <p class="d-inline-block ml-2 body-2-2 mb-0 text-black">{{$t('merchant.today')}}, {{formatHour(getMerchant().time_start)}} - {{formatHour(getMerchant().time_end)}}</p>
          </template>
          <div class="d-block mt-2 ml-4" v-if="opening_days">
            <div class="w-100 mb-2" v-if="getMerchant().sale_sunday">
              <span class="dot-green ml-2 mr-1 d-inline-block align-middle"></span><p class="mb-0 body-2-2 pl-2 d-inline-block align-middle">{{$t('general.days.sunday')}}</p>
            </div>
            <div class="w-100 mb-2" v-if="getMerchant().sale_monday">
              <span class="dot-green ml-2 mr-1 d-inline-block align-middle"></span><p class="mb-0 body-2-2 pl-2 d-inline-block align-middle">{{$t('general.days.monday')}}</p>
            </div>
            <div class="w-100 mb-2" v-if="getMerchant().sale_tuesday">
              <span class="dot-green ml-2 mr-1 d-inline-block align-middle"></span><p class="mb-0 body-2-2 pl-2 d-inline-block align-middle">{{$t('general.days.tuesday')}}</p>
            </div>
            <div class="w-100 mb-2" v-if="getMerchant().sale_wednesday">
              <span class="dot-green ml-2 mr-1 d-inline-block align-middle"></span><p class="mb-0 body-2-2 pl-2 d-inline-block align-middle">{{$t('general.days.wednesday')}}</p>
            </div>
            <div class="w-100 mb-2" v-if="getMerchant().sale_thursday">
              <span class="dot-green ml-2 mr-1 d-inline-block align-middle"></span><p class="mb-0 body-2-2 pl-2 d-inline-block align-middle">{{$t('general.days.thursday')}}</p>
            </div>
            <div class="w-100 mb-2" v-if="getMerchant().sale_friday">
              <span class="dot-green ml-2 mr-1 d-inline-block align-middle"></span><p class="mb-0 body-2-2 pl-2 d-inline-block align-middle">{{$t('general.days.friday')}}</p>
            </div>
            <div class="w-100 mb-2" v-if="getMerchant().sale_saturday">
              <span class="dot-green ml-2 mr-1 d-inline-block align-middle"></span><p class="mb-0 body-2-2 pl-2 d-inline-block align-middle">{{$t('general.days.saturday')}}</p>
            </div>
          </div>
        </div>
        <div class="row grid-slim-row">
          <div class="col-1">
          </div>
          <div class="col-9">
            <p class="d-inline-block body-2-4 my-2" style="color: #79A33A" @click="opening_days = !opening_days">
              <template v-if="opening_days">
                {{$t('general.close')}}
              </template>
              <template v-else>
                {{$t('merchant.see-all-opening-days')}}
              </template>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container border-bottom">
      <div class="row text-center border-top-bottom" style="padding: 12px 0px 10px">
          <div class="col-3">
            <a :href="'tel:'+getMerchant().phone">
            <div class="text-center d-inline-block align-bottom">
              <img src="../../assets/img/icon/phone-black.png" width="22">
              <p class="body-2 text-12 pt-1 mb-0">{{$t('restaurant.menu.call')}}</p>
            </div>
            </a>
          </div>
        <div class="col-3">
          <router-link :to="'/'+getMerchant().code+'/feedback'">
            <div class="text-center d-inline-block align-bottom">
              <img src="../../assets/img/icon/review.png" width="22">
              <p class="body-2 text-12 pt-1 mb-0">{{$t('restaurant.menu.review')}}</p>
            </div>
          </router-link>
        </div>
        <div class="col-3">
          <router-link :to="'/'+getMerchant().code+'/gallery'">
            <div class="text-center d-inline-block align-bottom">
              <img src="../../assets/img/icon/ar-camera.png" width="22">
              <p class="body-2 text-12 pt-1 mb-0">{{$t('restaurant.menu.gallery')}}</p>
            </div>
          </router-link>
        </div>
        <div class="col-3">
          <div class="text-center d-inline-block align-bottom cursor-pointer" @click="shareClick()">
            <img src="../../assets/img/icon/share.png" width="22">
            <p class="body-2 text-12 pt-1 mb-0">{{$t('restaurant.menu.share')}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container pt-3 mb-2" v-if="getMerchant().highlights != '' || getMerchant().highlights != null">
      <div class="px-2">
        <p class="heading-5 text-black mb-1">{{$t('merchant.highlights')}}</p>
        <p class="d-inline-block body-2-2-1 mb-1" v-html="getMerchant().highlights"></p>
      </div>
    </div>
    <div class="container pt-3 mb-2" v-if="getMerchant().experience != '' || getMerchant().experience != null">
      <div class="px-2">
        <p class="heading-5 text-black mb-1">{{$t('merchant.what-you-will-experience')}}</p>
          <p class="body-2-2-1" v-html="getMerchant().experience"></p>
      </div>
    </div>
    <div class="container pt-3 mb-2" v-if="getMerchant().facilities.length != 0">
      <p class="heading-5 text-black mb-2">{{$t('merchant.facilities')}}</p>
      <div class="mb-2">
        <div v-if="getMerchant().facilities.length > 5" class="d-inline-block text-left position-relative mobile-none" style="top: -30px;" @click="scrollLeftReview">
          <img src="../../assets/img/icon/down-arrow.png" width="20" style="transform: rotate(90deg);">
        </div>
        <div class="div-wrappers mx-auto m-width-100" :class="{'d-inline-block' : getMerchant().facilities.length > 5}" style="width: 88%;">
          <div class="text-center mx-auto" style="width: max-content">
            <div class="width-50 text-center d-inline-block align-bottom" v-for="facilities in getMerchant().facilities">
              <i :class="facilities.icon"></i>
              <p class="body-p pt-1 mb-0">{{facilities.name}}</p>
            </div>
          </div>
        </div>
        <div v-if="getMerchant().facilities.length > 5" class="d-inline-block text-right position-relative mobile-none" style="top: -30px;" @click="scrollRightReview">
          <img src="../../assets/img/icon/down-arrow.png" width="20" style="transform: rotate(-90deg);">
        </div>
      </div>
    </div>
    <div class="container pt-3 mb-2">
      <div class="px-2">
        <p class="heading-5 text-black mb-1">{{$t('merchant.location-detail')}}</p>
          <p class="body-2-2-1">{{getMerchant().address}}</p>
      </div>
    </div>
    <div class="mb-5 w-100">
      <ShowGmaps />
    </div>
    <div class="container pt-2 mb-2 border-bottom" @click="toggleData('redeem')" v-if="getMerchant().how_to_redeem != ''">
      <div class="px-2 ">
        <div class="row">
          <div class="col-10">
            <p class="text-left d-inline-block sub-heading-1-1 text-black">{{$t('merchant.how-to-redeem')}}</p>
          </div>
          <div class="col-1">
            <img src="../../assets/img/icon/down-arrow.png" :class="{'rotate-180': toggle_data == 'redeem'}" class="d-inline-block text-right" width="18">
          </div>
        </div>
      </div>
      <transition name="list">
      <div class="px-4" v-if="toggle_data == 'redeem'">
        <p class="body-2-2-1" v-html="getMerchant().how_to_redeem"></p>
      </div>
      </transition>
    </div>
    <div class="container pt-2 mb-2 border-bottom" @click="toggleData('term')" v-if="getMerchant().terms_and_conditions != ''">
      <div class="px-2 ">
        <div class="row">
          <div class="col-10">
            <p class="text-left d-inline-block sub-heading-1-1 text-black">{{$t('merchant.term-condition')}}</p>
          </div>
          <div class="col-1">
             <img src="../../assets/img/icon/down-arrow.png" :class="{'rotate-180': toggle_data == 'term'}" class="d-inline-block text-right" width="18">
          </div>
        </div>
      </div>
      <transition name="list">
        <div class="px-4" v-if="toggle_data == 'term'">
          <p class="body-2-2-1" v-html="getMerchant().terms_and_conditions"></p>
        </div>
      </transition>
    </div>
    <div class="container pt-2 mb-2 border-bottom" @click="toggleData('cancel')" v-if="getMerchant().cancellation_policy != ''">
      <div class="px-2 ">
        <div class="row">
          <div class="col-10">
            <p class="text-left d-inline-block sub-heading-1-1 text-black">{{$t('merchant.cancellation-policy')}}</p>
          </div>
          <div class="col-1">
             <img src="../../assets/img/icon/down-arrow.png" :class="{'rotate-180': toggle_data == 'cancel'}" class="d-inline-block text-right" width="18">
          </div>
        </div>
      </div>
      <transition name="list">
        <div class="px-4" v-if="toggle_data == 'cancel'">
          <p class="body-2-2-1" v-html="getMerchant().cancellation_policy"></p>
        </div>
      </transition>
    </div>
    <div class="mb-5 pt-4"></div>
    <div class="py-0 fixed-bottom z-index-1028" style="bottom: 8%;" v-if="scrollPosition >= 120">
      <div class="w-100">
        <b-row class="justify-content-center" no-gutters>
          <b-col cols="12" sm="8" md="6" lg="4" xl="4" class="py-2 bg-white">
            <div class="w-100">
              <b-row no-gutters>
                <div class="container bg-white pb-2">
                  <div class="row">
                    <div class="col-6">
                      <p class="mb-0 body-3-3-1 text-black" style="margin-bottom: -7px !important;">{{$t('merchant.starting-from')}}</p>
                      <template v-if="getMerchant().starting_dsc_pct == 0">
                        <p class="mb-1 mt-2 sub-heading-1-2 text-color-orange">{{formatCurrency(getMerchant().starting_price_sell)}}</p>
                      </template>
                      <template v-else>
                        <p class="mb-0 d-inline-block body-3-3-1 text-line-through" style="color: #9BA1AA">{{formatCurrency(getMerchant().starting_dsc_product)}}</p>
                        <p class="mb-1 sub-heading-1-2 text-color-orange">{{formatCurrency(getMerchant().starting_price_sell)}}</p>
                      </template>
                    </div>
                    <div class="col-6">
                      <router-link :to="'/'+getMerchant().code+'/list'">
                        <p class="mb-0 body-2-4 text-white bg-orange text-center mt-1 mx-auto rounded-15 " style="padding-top: 13px;padding-bottom: 13px;">{{$t('merchant.find-tickets')}}</p>
                      </router-link>
                    </div>
                  </div>
                </div>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get} from '@/services/index.js'
  import {customFormatDateTime,formatCurrency} from '@/utils/index.js'
  import {mapGetters, mapActions} from "vuex";
  import Flickity from 'vue-flickity';
  import moment from 'moment';

  export default {
    components: {
      Flickity
    },
    data() {
      return {
        flickityOptions: {
          initialIndex: 0,
          autoPlay: 2500,
          wrapAround: true,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: true,
          draggable: true,
        },
        scrollPosition: null,
        merchant_is_load: false,
        merchant: {},
        merchant_area: '',
        is_today_available: false,
        opening_days: false,
        toggle_data: '',
        map:{
          center: { lat: null, lng: null },
          markers: []
        },
        action_success:{
          show: false,
          message: '',
          timer: 0
        }      
      }
    },
    computed:{
      show_success(){
        return this.action_success.show
      }
    },
    watch:{
      show_success(){
        if (this.action_success.show) {
          let looping = setInterval(() => {
            if (this.action_success.timer > 0) {
              this.action_success.timer--
            }else if(this.action_success.timer == 0){
              this.action_success.show = false
              this.action_success.message = ''
              clearInterval(looping)
            }
          },1000) 
        }
      }
    },
    mounted() {
      document.getElementById('merchant').scrollIntoView({
          behavior: 'smooth'
      });
      window.addEventListener('scroll', this.updateScroll);
      this.loadMerchantArea()
      this.checkIfTodayIsOpen()
      this.map.center = {
        lat : this.getMerchant().lat,
        lng : this.getMerchant().lng
      }
      this.map.markers = []
      this.map.markers.push({ position: this.center });
    },
    methods: {
      ...mapGetters(['getMerchant','getTicketCart']),
      ...mapActions(['setMerchant']),
      toggleData(data) {
        if (this.toggle_data == data) {
          this.toggle_data = ''
        }else{
          this.toggle_data = data
        }
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
      updateScroll() {
        this.scrollPosition = window.scrollY
      },
      formatHour(time){
        return customFormatDateTime(time, 'HH:mm:ss', 'HH:mm')
      },
      checkIfTodayIsOpen(){
        let today = moment().format("d")
        switch(today){

          case '0' :
            if (this.getMerchant().sale_sunday)
              this.is_today_available = true
            else
              this.is_today_available = false
            break;

          case '1' :
            if (this.getMerchant().sale_monday)
              this.is_today_available = true
            else
              this.is_today_available = false
            break;

          case '2' :
            if (this.getMerchant().sale_tuesday)
              this.is_today_available = true
            else
              this.is_today_available = false
            break;

          case '3' :
            if (this.getMerchant().sale_wednesday)
              this.is_today_available = true
            else
              this.is_today_available = false
            break;

          case '4' :
            if (this.getMerchant().sale_thursday)
              this.is_today_available = true
            else
              this.is_today_available = false
            break;

          case '5' :
            if (this.getMerchant().sale_friday)
              this.is_today_available = true
            else
              this.is_today_available = false
            break;

          case '6' :
            if (this.getMerchant().sale_saturday)
              this.is_today_available = true
            else
              this.is_today_available = false
            break;

          default :
            this.is_today_available = false
        }
      },
      scrollLeftReview() {
        let content = document.querySelector(".div-wrappers");
        content.scrollLeft -= 80;
      },
      scrollRightReview() {
        let content = document.querySelector(".div-wrappers");
        content.scrollLeft += 80;
      },
      loadMerchantArea(){
        get("CORE","user-location",{
          lat: this.getMerchant().lat,
          long: this.getMerchant().lng
        }).then(response=>{
          let location_type = response.data.data.address_components
            for(let i = 0; i < location_type.length;i++){
                if (location_type[i].types[0] == 'administrative_area_level_3') {
                    this.merchant_area = location_type[i].short_name;
                    break;
                }
            }
        })
      },
      shareClick(){
        var value = window.location.href;
        var input_temp = document.createElement("input");
        input_temp.value = value;
        document.body.appendChild(input_temp);
        input_temp.select();
        document.execCommand("copy");
        document.body.removeChild(input_temp);
        this.action_success.show = true
        this.action_success.message = 'Link ('+value+') Copied'
        this.action_success.timer = 2
      }
    }
  }

</script>
<style scoped>
  .rotate-180{
    transform: rotate(180deg);
  }
  .pop-up{
    height: 100vh;
    overflow: scroll;
  }

  .flickity-page-dots .dot{
    background-color: #79a33a !important;
  }

  .review-img{
    border-radius: 50%;
    object-fit: cover;
  }

  .object-fit{
    object-fit: cover;
  }

  .slide-review{
    height: auto !important;
  }

  .list-enter,
  .list-leave-to {
    visibility: hidden;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }

  .list-enter-active,
  .list-leave-active {
    transition: all 0.3s;
  }

  .slide-detail{
    display: inline-block;
    width: 100px;
    height: 100px;
  }

  .text-black {
    color: #000 !important;
  }

  .body-p {
    font-size: 10px;
    font-family: Nunito-Regular;
    color: #9BA1AA;
    letter-spacing: 0.25px;
  }

  .width-50 {
    width: 50px !important;
    height: 55px;
    margin: 0 8px;
  }

  .div-wrapper {
    overflow-x: auto;
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }

  .div-wrapper::-webkit-scrollbar {
      display: none !important;
  }

  .div-wrappers {
    overflow-x: auto;
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }

  .div-wrappers::-webkit-scrollbar {
      display: none !important;
  }
  
  @media screen and (max-width: 600px) {
    
    .m-width-100{
      width: 100% !important;
    }

    .mobile-none{
      display: none !important;
    }

  }
  
</style>



// WEBPACK FOOTER //
// src/pages/ticket/MerchantDetail.vue